var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text d-flex align-center",style:(_vm.style)},[_c('img',{staticClass:"icon mr-2",attrs:{"src":_vm.templateItemData.icon,"alt":"Icon"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.templateItemData.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }